import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./page/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import AdminSidebar from "./components/AdminSidebar";
import MedicineManager from "./components/MedicineManager";
import OrderManager from "./components/OrderManager";
import UserManager from "./components/UserManager";
import SellManager from "./components/SellManager";
import AdminDashboard from "./components/AdminDashboard";
import MedicinePage from "./page/MedicinePage";
import DoctorCard from "./page/DoctorCard";
import DoctorManager from "./components/DoctorManager";
import UserProfile from "./components/UserProfile";

import OrderDetailsPage from "./components/OrderDetailsPage";
import AllOrdersPage from "./components/AllOrdersPage";
import OrderSummary from "./components/OrderSummary";
import LocationFetcher from "./com/LocationFetcher";
import DoctorSignup from "./components/DoctorSignup";
import DoctorProfileList from "./components/DoctorProfile";
import DoctorProfileForm from "./components/DoctorProfileForm";
import UserOrders from "./components/UserOrders";
import LabTestPage from "./components/LabTestPage";
import LabTestPageWithStyles from "./components/LabeTestPageWithStyles";
import MakeBillPage from "./com/MakeBillPage";
import B2BRegister from "./page/B2BRegister";
import DataFileUploader from "./components/DataFileUploader";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/as" element={<AdminSidebar/>} />
        <Route path="/mm" element={<MedicineManager/>} />
        <Route path="/om" element={<OrderManager/>} />
        <Route path="/um" element={<UserManager/>} />
        <Route path="/sm" element={<SellManager/>} />
        <Route path="/ad" element={<AdminDashboard/>} />
        <Route path="/su" element={<Signup/>} />
        <Route path="/mp" element={<MedicinePage/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/dc" element={<DoctorCard/>} />
        <Route path="/dm" element={<DoctorManager/>} />
        <Route path="/up" element={<UserProfile/>} />
        <Route path="/od" element={<AllOrdersPage/>} />
        <Route path="/os" element={<OrderSummary/>} />
        <Route path="/lt" element={<LocationFetcher/>} />
        <Route path="/ds" element={<DoctorSignup/>} />
        <Route path="/dp" element={<DoctorProfileList/>} />
        <Route path="/df" element={<DoctorProfileForm/>} />
        <Route path="/uoo" element={<UserOrders/>} />
        <Route path="/ltp" element={<LabTestPageWithStyles/>} />
        <Route path="/mb" element={<MakeBillPage/>} />
        <Route path="/b2b" element={<B2BRegister/>} />
        <Route path="/dft" element={<DataFileUploader/>} />
       
      </Routes>
    </Router>
  );
}

export default App;
